import CuNotesDeliver from './Cu-NotesDeliver.vue';
export default CuNotesDeliver;


// WEBPACK FOOTER //
// ./src/packages/NotesDeliver/CuNotesDeliver/index.js